var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCabinets(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Icons",
    viewBox: "0 0 60 60",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58,0H2A2,2,0,0,0,0,2V4A1.993,1.993,0,0,0,1,5.722V50.278A1.993,1.993,0,0,0,0,52v2a2,2,0,0,0,2,2v1a3,3,0,0,0,3,3h6a3,3,0,0,0,3-3V56H46v1a3,3,0,0,0,3,3h6a3,3,0,0,0,3-3V56a2,2,0,0,0,2-2V52a1.993,1.993,0,0,0-1-1.722V5.722A1.993,1.993,0,0,0,60,4V2A2,2,0,0,0,58,0ZM2,2H58V4H2ZM57,50H31V6H57ZM3,50V6H29V50Zm9,7a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V56h8Zm44,0a1,1,0,0,1-1,1H49a1,1,0,0,1-1-1V56h8Zm1-3H2V52H58v2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26,27a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0V28A1,1,0,0,0,26,27Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34,32a1,1,0,0,0,1-1V28a1,1,0,0,0-2,0v3A1,1,0,0,0,34,32Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11a3,3,0,0,0-3-3H10a3,3,0,0,0-3,3V23a3,3,0,0,0,3,3H22a3,3,0,0,0,3-3ZM23,23a1,1,0,0,1-1,1H10a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H22a1,1,0,0,1,1,1Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13,12H12a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20,12H17a1,1,0,0,0,0,2h3a1,1,0,0,0,0-2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13,16H12a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16H17a1,1,0,0,0,0,2h3a1,1,0,0,0,0-2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13,20H12a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H17a1,1,0,0,0,0,2h3a1,1,0,0,0,0-2Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38,26H50a3,3,0,0,0,3-3V11a3,3,0,0,0-3-3H38a3,3,0,0,0-3,3V23A3,3,0,0,0,38,26ZM37,11a1,1,0,0,1,1-1H50a1,1,0,0,1,1,1V23a1,1,0,0,1-1,1H38a1,1,0,0,1-1-1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M40,14h1a1,1,0,0,0,0-2H40a1,1,0,0,0,0,2Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45,14h3a1,1,0,0,0,0-2H45a1,1,0,0,0,0,2Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M40,18h1a1,1,0,0,0,0-2H40a1,1,0,0,0,0,2Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45,18h3a1,1,0,0,0,0-2H45a1,1,0,0,0,0,2Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M40,22h1a1,1,0,0,0,0-2H40a1,1,0,0,0,0,2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45,22h3a1,1,0,0,0,0-2H45a1,1,0,0,0,0,2Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M16.231,30.36l-5,6A1,1,0,0,0,12,38h2l-3,4V40a1,1,0,0,0-2,0v5a1,1,0,0,0,1,1,.991.991,0,0,0,.371-.071l5-2a1,1,0,1,0-.742-1.858l-1.689.676L16.8,37.6A1,1,0,0,0,16,36H14.135l3.634-4.36a1,1,0,0,0-1.538-1.28Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50,39a1,1,0,0,0-1,1v2l-3-4h2a1,1,0,0,0,.769-1.64l-5-6a1,1,0,0,0-1.538,1.28L45.865,36H44a1,1,0,0,0-.8,1.6l3.86,5.147-1.689-.676a1,1,0,1,0-.742,1.858l5,2a1,1,0,0,0,.932-.1A1,1,0,0,0,51,45V40A1,1,0,0,0,50,39Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCabinets);
export default __webpack_public_path__ + "static/media/cabinets.f8466a9b1a044e2d4efb757dc6de0bbd.svg";
export { ForwardRef as ReactComponent };